const COLOR_PICKER_BG = {
    'color-picker-bg-65': '#0cafd2',
    'color-picker-bg-78': '#5756ce',
    'color-picker-bg-69': '#ef5316',
    'color-picker-bg-70': '#e84459',
    'color-picker-df-bg-6' : '#008449',
    'color-picker-df-bg-1': '#3a87ad',
    'color-picker-bg-79': '#132f53',
    'color-picker-bg-72': '#e9af0f',
}

const ELEARNING_STATUS_LABEL = {
    'created': 'Không có dữ liệu',
    'in_progress': 'CHƯA ĐẠT',
    'completed': 'ĐẠT',
}

export {
    COLOR_PICKER_BG,
    ELEARNING_STATUS_LABEL,
}
